<template>
  <div :class="{'ground-full':_route.meta && _route.meta.groundFull}">
    <a href="#/search" @click="backToSearch($event)">
      <div class="logo">
        <img src="../assets/img/gosedan-log.png" v-if="brandCode === 'gs'"/>
        <img src="https://prod-opoli-app.s3.us-west-2.amazonaws.com/web/s2a-logo.png" v-if="brandCode === 's2l'"/>
        <img src="https://prod-opoli-app.s3.us-west-2.amazonaws.com/web/PTSLOGO-01.png" v-if="brandCode === 'pts'"/>
      </div>
    </a>
    <div class="progress-bar-wrap medium-padding-h-s" v-if="progressIndex >= 0">
      <div class="progress-bar-title">
        <h3 class="margin-a-z">{{ steps[progressIndex].label }}</h3>
      </div>
      <div class="row progress-bar">
        <div class="small-3 columns no-padding" v-for="(step, index) in steps" :key="index">
          <a :href="`#/${step.link}`" :class="['step-link', {active: progressIndex == index, disabled:step.disabled}]"
            @click="navigate($event, step.link)" v-if="step.link !== '#'">
            <span class='full-title'>{{ (index+1) +'. '+ step.label }}</span>
            <span class='step-title'>{{ index+1 }}</span>
          </a>
          <a :class="['step-link', {active: progressIndex == index, disabled:step.disabled}]"
            @click="backToServiceSelection($event)" v-else>
            <span class='full-title'>{{ (index+1) +'. '+ step.label }}</span>
            <span class='step-title'>{{ index+1 }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: [ 'backLink' ],
  data () {
    return {}
  },
  computed: {
    progressIndex () { return this.$store.state.currentIndex },
    steps () { return this.$store.state.progressSteps },
    brandCode () { return this.$store.state.brandCode },
    _route () { return this.$route }
  },
  methods: {
    backToSearch (event) {
      if (event) event.preventDefault()
      this.$root.$router.push('search')
      window.location.href = '#/search'
    },
    backToServiceSelection (event) {
      if (event) event.preventDefault()
      this.$root.$router.push('service')
      window.location.href = '#/service'
      // this.$root.$router.push('service')
    },
    navigate (event, link) {
      if (event) event.preventDefault()
      this.$root.$router.push(link)
      window.location.href = `#/${link}`
      // this.$root.$router.push(link)
    }
  },
  watch: {
    backLink: function (link) { this.$store.commit('setBackLink', link) }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ground-full{
  margin: 0 auto;
}
.logo{
  text-align: center;
  margin-bottom: 20px;
  img { width: 250px; }
}
@import "../assets/scss/ProgressBar.scss";
.progress-bar .columns .step-link{
  span{
    color: #333!important;
  }
  &.disabled{
    span{
      color: #bbb!important
    }
  }
  &.active{
    span{
      color: #fff!important
    }
  }
}
</style>



// WEBPACK FOOTER //
// ProgressBar.vue?a7f8a0a0